import store from "../app/store";

/**
 * Fetches the list of documents used by a specific bot.
 *
 * - Sends a `GET` request to the backend with the bot's ID as a query parameter.
 * - Uses an authorization token from the Redux store.
 *
 * @async
 * @function GetBotUsedDoc
 * @param {string} botID - The unique identifier of the bot whose documents are to be fetched.
 * @returns {Promise<{data: any[] | null, error: boolean | string}>} A promise that resolves to an object containing:
 * - `data`: An array of document data used by the bot (or `null` if token is missing).
 * - `error`: `false` if successful, `true` or error message string if failed.
 *
 * @example
 * const result = await GetBotUsedDoc("abc123");
 * if (!result.error) {
 *   console.log("Documents used by bot:", result.data);
 * } else {
 *   console.error("Error fetching documents:", result.error);
 * }
 */

const GetBotUsedDoc = async (botID) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/bot/get_doc_used_bot?bot_id=${botID}`;

  const token = store.getState().auth.token;

  if (!token) {
    return { data: null, error: "No token found" };
  }
  const option = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const res = await fetch(url, option);
  if (res.status === 200) {
    const data = await res.json();
    return { data: data?.data, error: false };
  } else {
    return { data: [], error: true };
  }
};
export default GetBotUsedDoc;
